import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { EMPLOYEE_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetEmpAuditLogsProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getEmpAuditLogs = async (data: any) =>
  await axiosAuth.post(`${EMPLOYEE_API}/audit/history/grid`, data);

const useGetEmpAuditLogs = ({
  data,
  queryParams,
}: UseGetEmpAuditLogsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["audit-logs"],
    queryFn: () => getEmpAuditLogs(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetEmpAuditLogs;
